/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PagedResultDto_GetEmailNotificationDto } from '../models/PagedResultDto_GetEmailNotificationDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class NotificationService {

    /**
     * @param notificationId 
     * @returns boolean OK
     * @throws ApiError
     */
    public static putApiNotificationApiAppNotificationNotificationSeen(
notificationId: string,
): CancelablePromise<boolean> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/notification/api/app/notification/notification-seen/{notificationId}',
            path: {
                'notificationId': notificationId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param userId 
     * @param message 
     * @returns string OK
     * @throws ApiError
     */
    public static postApiNotificationApiAppNotificationTestBellNotification(
userId: string,
message?: string,
): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/notification/api/app/notification/test-bell-notification/{userId}',
            path: {
                'userId': userId,
            },
            query: {
                'message': message,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public static postApiNotificationApiAppNotificationTestEmailNotification(): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/notification/api/app/notification/test-email-notification',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns boolean OK
     * @throws ApiError
     */
    public static deleteApiNotificationApiAppNotificationNotifications(): CancelablePromise<boolean> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/notification/api/app/notification/notifications',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param notificationId 
     * @returns boolean OK
     * @throws ApiError
     */
    public static deleteApiNotificationApiAppNotificationNotification(
notificationId: string,
): CancelablePromise<boolean> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/notification/api/app/notification/notification/{notificationId}',
            path: {
                'notificationId': notificationId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param title 
     * @param notificationMedium 
     * @param notificationType 
     * @param isSent 
     * @param isSeen 
     * @param filter 
     * @param isActive 
     * @param sorting 
     * @param skipCount 
     * @param maxResultCount 
     * @returns PagedResultDto_GetEmailNotificationDto OK
     * @throws ApiError
     */
    public static getApiNotificationApiAppNotificationEmailNotificationList(
title?: string,
notificationMedium?: string,
notificationType?: string,
isSent?: boolean,
isSeen?: boolean,
filter?: string,
isActive?: boolean,
sorting?: string,
skipCount?: number,
maxResultCount?: number,
): CancelablePromise<PagedResultDto_GetEmailNotificationDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/notification/api/app/notification/email-notification-list',
            query: {
                'Title': title,
                'NotificationMedium': notificationMedium,
                'NotificationType': notificationType,
                'IsSent': isSent,
                'IsSeen': isSeen,
                'Filter': filter,
                'IsActive': isActive,
                'Sorting': sorting,
                'SkipCount': skipCount,
                'MaxResultCount': maxResultCount,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public static postApiNotificationApiAppNotificationTestForgotPasswordEmailNotification(): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/notification/api/app/notification/test-forgot-password-email-notification',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
